import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { EquipmentService } from '../../../../services/equipment.service';
import { Equipment } from '../../../../models/equipment';
import { AuthService } from '../../../../services/auth.service';
import { UUID } from 'angular2-uuid';
import { LocationService } from '../../../../services/location.service';
import { ModalService } from '../../../../services/modal.service';
import * as moment from 'moment';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'app-asset-manage',
  templateUrl: './asset-manage.component.html',
  styleUrls: ['./asset-manage.component.scss']
})
export class AssetManageComponent implements OnInit {
  @ViewChild("date_Of_First_Use_Calendar", { static: false }) private calendar: Calendar;

  id: string = null;
  equip: any;
  companyId: string = '';
  editMode: boolean = false;
  user;
  subLocationName: String = "";
  triggerSubLocationUpdate: boolean = false;


  constructor(private authService: AuthService, private router: Router, private modalService: ModalService, private snotifyService: SnotifyService, public equipmentService: EquipmentService, private locationService: LocationService) {
    this.user = this.authService.currentUser.value;
  }

  ngOnInit(): void {
    this.equip = new Equipment();

    var id = this.router.parseUrl(this.router.url).queryParams["id"];
    this.companyId = this.router.parseUrl(this.router.url).queryParams["company_Id"];
    this.equip.company_Id = this.companyId;
    if (id != null) {
      this.equipmentService.get(id).then((e) => {
        this.equip = e;
        this.editMode = true;
      });
    }
  }

  back() {
    this.router.navigate(['admin/assets/'], { queryParams: { id: this.companyId } });
  }

  validate() {
    if (this.equip.location_Id == null || this.equip.location_Id == "" || this.equip.location_Id == 0) {
      this.snotifyService.error("Please enter a Location");
      return false;
    }
    if (this.equip.category_Id == null || this.equip.category_Id == "" || this.equip.category_Id == 0) {
      this.snotifyService.error("Please enter a Category");
      return false;
    }
    // if (this.equip.manufacturer_Id == null || this.equip.manufacturer_Id == "" || this.equip.manufacturer_Id == 0) {
    //   this.snotifyService.error("Please enter a Manufacturer");
    //   return false;
    // }


    if (this.equip.description == null || this.equip.description == "") {
      this.snotifyService.error("Please enter a description");
      return false;
    }
    if (this.equip.serial_Num == null || this.equip.serial_Num == "") {
      this.snotifyService.error("Please enter a Serial #");
      return false;
    }

    if (this.equip.swl == null || this.equip.swl == "") {
      this.snotifyService.error("Please enter a safe working load");
      return false;
    }

    return true;
  }
  addSublocation() {
    if (this.equip.location_Id == undefined || this.equip.location_Id == null) {
      this.snotifyService.error("Please select a location");
      return;
    }
    this.openModal('popup-sublocation-add');
  }


  saveSubLocation() {
    if (this.subLocationName == undefined || this.subLocationName == null || this.subLocationName == "") {
      this.snotifyService.error("Please enter a name");
      return;
    }
    var id = UUID.UUID();
    var sublocation = {
      id: id,
      name: this.subLocationName,
      location_Id: this.equip.location_Id,
      userId: this.user.id
    }

    this.locationService.savesublocation(sublocation).then((data) => {

      this.triggerSubLocationUpdate = !this.triggerSubLocationUpdate;
      this.subLocationName = undefined;
      this.onSublocationChange(sublocation);
      this.cancelModal('popup-sublocation-add');
    });
  }

  onSublocationChange(value) {
    if (value == undefined)
      this.equip.sublocation_Id = undefined;
    else
      this.equip.sublocation_Id = value.id;
  }

  openModal(id) {
    this.modalService.open(id);
  }
  cancelModal(id) {
    this.modalService.close(id);
  }

  async save() {
    //console.log(this.equip);
    if (!this.validate()) {
      return;
    }

    this.equip.userId = this.user.id;

    if (!this.editMode)
      await this.equipmentService.add(this.equip);
    else
      await this.equipmentService.update(this.equip);

    this.back();
  }

  async delete() {
    await this.equipmentService.delete(this.equip.id, this.user.id);
    this.back();
  }

  onLocationChange(value) {
    //console.log("location:");
    //console.log(value);
    if (value == undefined)
      this.equip.location_Id = undefined;
    else
      this.equip.location_Id = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.equip.category_Id = undefined;
    else
      this.equip.category_Id = value.id;

    this.equip.reportType = value.reportType;
    console.log(this.equip.reportType);
  }
  onManufacturerChange(value) {
    if (value == undefined)
      this.equip.manufacturer_Id = undefined;
    else
      this.equip.manufacturer_Id = value.id;
  }
    openCalendar(event: any) {
      var examDate = moment(this.equip.date_Of_First_Use);
      if (!examDate.isValid()) {
        this.equip.date_Of_First_Use_Date = moment().toDate();
      } else {
        this.equip.date_Of_First_Use_Date = moment(this.equip.date_Of_First_Use).toDate();
      }
  
      this.calendar.showOverlay();
      event.stopPropagation();
    }
    onCalendarChange() {
      this.equip.date_Of_First_Use = moment(this.equip.date_Of_First_Use_Date).format('DD/MM/yyyy')
    }
}
